import React, { useState, useEffect } from 'react';
import { 
  Camera, 
  Grid, 
  Eye, 
  Download, 
  X, 
  ChevronLeft, 
  ChevronRight, 
  Share2,
  Upload,
  Sparkles,
  Filter,
  Search,
  Heart,
  Star
} from 'lucide-react';

const PhotoGallery = ({ isActive, selectedProperty }) => {
  const [photos, setPhotos] = useState([]);
  const [filteredPhotos, setFilteredPhotos] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [lightboxPhoto, setLightboxPhoto] = useState(null);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  // Real Mannheim D3,1 photos data
  const mannheimPhotos = [
    // Living Room / Wohnzimmer
    { id: '1000006814', url: '/assets/property-visualizer/mannheim-d31/general/1000006814.jpg', title: 'Wohnzimmer - Hauptansicht', category: 'living', room: 'Wohnzimmer', description: 'Offener Wohnbereich mit modernem Design' },
    { id: '1000006812', url: '/assets/property-visualizer/mannheim-d31/general/1000006812.jpg', title: 'Wohnzimmer - Sitzbereich', category: 'living', room: 'Wohnzimmer', description: 'Gemütlicher Sitzbereich mit Blick zum Balkon' },
    { id: '1000006810', url: '/assets/property-visualizer/mannheim-d31/general/1000006810.jpg', title: 'Wohnzimmer - Panorama', category: 'living', room: 'Wohnzimmer', description: 'Panoramablick des Wohnbereichs' },
    { id: '1000006807', url: '/assets/property-visualizer/mannheim-d31/general/1000006807.jpg', title: 'Wohnzimmer - Detail', category: 'living', room: 'Wohnzimmer', description: 'Detailansicht der Wohnraumgestaltung' },
    
    // Kitchen / Küche
    { id: '1000006815', url: '/assets/property-visualizer/mannheim-d31/general/1000006815.jpg', title: 'Küche - Hauptansicht', category: 'kitchen', room: 'Küche', description: 'Moderne Einbauküche mit hochwertigen Geräten' },
    { id: '1000006816', url: '/assets/property-visualizer/mannheim-d31/general/1000006816.jpg', title: 'Küche - Arbeitsbereich', category: 'kitchen', room: 'Küche', description: 'Funktionaler Arbeitsbereich der Küche' },
    
    // Bedrooms / Schlafzimmer
    { id: '1000006840', url: '/assets/property-visualizer/mannheim-d31/general/1000006840.jpg', title: 'Schlafzimmer I - Hauptansicht', category: 'bedroom', room: 'Schlafzimmer I', description: 'Geräumiges Hauptschlafzimmer im Dachgeschoss' },
    { id: '1000006842', url: '/assets/property-visualizer/mannheim-d31/general/1000006842.jpg', title: 'Schlafzimmer I - Detail', category: 'bedroom', room: 'Schlafzimmer I', description: 'Detailansicht des Hauptschlafzimmers' },
    { id: '1000006847', url: '/assets/property-visualizer/mannheim-d31/general/1000006847.jpg', title: 'Schlafzimmer II', category: 'bedroom', room: 'Schlafzimmer II', description: 'Zweites Schlafzimmer mit Dachschräge' },
    { id: '1000006834', url: '/assets/property-visualizer/mannheim-d31/general/1000006834.jpg', title: 'Schlafzimmer III - Ansicht 1', category: 'bedroom', room: 'Schlafzimmer III', description: 'Drittes Schlafzimmer, ideal als Büro nutzbar' },
    { id: '1000006844', url: '/assets/property-visualizer/mannheim-d31/general/1000006844.jpg', title: 'Schlafzimmer III - Ansicht 2', category: 'bedroom', room: 'Schlafzimmer III', description: 'Alternative Ansicht des dritten Schlafzimmers' },
    
    // Bathroom / Badezimmer
    { id: '1000006805', url: '/assets/property-visualizer/mannheim-d31/general/1000006805.jpg', title: 'Badezimmer - Hauptansicht', category: 'bathroom', room: 'Badezimmer', description: 'Modernes Badezimmer mit Badewanne' },
    { id: '1000006806', url: '/assets/property-visualizer/mannheim-d31/general/1000006806.jpg', title: 'Badezimmer - Detail', category: 'bathroom', room: 'Badezimmer', description: 'Detailansicht der Badausstattung' },
    
    // Balcony / Balkon
    { id: '1000006809', url: '/assets/property-visualizer/mannheim-d31/general/1000006809.jpg', title: 'Balkon - Außenansicht', category: 'balcony', room: 'Balkon', description: 'Balkon mit Blick über Mannheim' },
    
    // Additional high-quality photos
    { id: '1000006193', url: '/assets/property-visualizer/mannheim-d31/general/1000006193.jpg', title: 'Außenansicht - Gebäude', category: 'exterior', room: 'Außenbereich', description: 'Außenansicht des Gebäudes' },
    { id: '1000006194', url: '/assets/property-visualizer/mannheim-d31/general/1000006194.jpg', title: 'Außenansicht - Eingang', category: 'exterior', room: 'Außenbereich', description: 'Eingangsbereich des Gebäudes' },
    { id: '1000006195', url: '/assets/property-visualizer/mannheim-d31/general/1000006195.jpg', title: 'Außenansicht - Fassade', category: 'exterior', room: 'Außenbereich', description: 'Fassadenansicht des Wohngebäudes' },
    
    // Additional interior shots
    { id: '1000006614', url: '/assets/property-visualizer/mannheim-d31/general/1000006614.jpg', title: 'Innenbereich - Flur', category: 'other', room: 'Flur', description: 'Flurbereich der Maisonette-Wohnung' },
    { id: '1000006653', url: '/assets/property-visualizer/mannheim-d31/general/1000006653.jpg', title: 'Innenbereich - Detail 1', category: 'other', room: 'Sonstiges', description: 'Innendetail der Wohnung' },
    { id: '1000006654', url: '/assets/property-visualizer/mannheim-d31/general/1000006654.jpg', title: 'Innenbereich - Detail 2', category: 'other', room: 'Sonstiges', description: 'Weitere Innenansicht' },
    { id: '1000006655', url: '/assets/property-visualizer/mannheim-d31/general/1000006655.jpg', title: 'Innenbereich - Detail 3', category: 'other', room: 'Sonstiges', description: 'Zusätzliche Innenansicht' },
    { id: '1000006656', url: '/assets/property-visualizer/mannheim-d31/general/1000006656.jpg', title: 'Innenbereich - Detail 4', category: 'other', room: 'Sonstiges', description: 'Weitere Detailansicht' },
    { id: '1000006657', url: '/assets/property-visualizer/mannheim-d31/general/1000006657.jpg', title: 'Innenbereich - Detail 5', category: 'other', room: 'Sonstiges', description: 'Zusätzliche Innenansicht' }
  ];

  const categories = [
    { id: 'all', name: 'Alle Fotos', icon: Grid },
    { id: 'living', name: 'Wohnzimmer', icon: Heart },
    { id: 'kitchen', name: 'Küche', icon: Star },
    { id: 'bedroom', name: 'Schlafzimmer', icon: Eye },
    { id: 'bathroom', name: 'Bad', icon: Download },
    { id: 'balcony', name: 'Balkon', icon: Camera },
    { id: 'exterior', name: 'Außenansicht', icon: Upload },
    { id: 'other', name: 'Sonstiges', icon: Filter }
  ];

  useEffect(() => {
    if (isActive) {
      setIsLoading(true);
      // Simulate loading delay for better UX
      setTimeout(() => {
        setPhotos(mannheimPhotos);
        setIsLoading(false);
      }, 500);
    }
  }, [isActive]);

  useEffect(() => {
    let filtered = photos;
    
    // Filter by category
    if (selectedCategory !== 'all') {
      filtered = filtered.filter(photo => photo.category === selectedCategory);
    }
    
    // Filter by search term
    if (searchTerm) {
      filtered = filtered.filter(photo => 
        photo.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        photo.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        photo.room.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    setFilteredPhotos(filtered);
  }, [photos, selectedCategory, searchTerm]);

  const categoriesWithCounts = categories.map(category => ({
    ...category,
    count: category.id === 'all' 
      ? photos.length 
      : photos.filter(photo => photo.category === category.id).length
  }));

  const openLightbox = (photo, index) => {
    setLightboxPhoto(photo);
    setLightboxIndex(index);
  };

  const closeLightbox = () => {
    setLightboxPhoto(null);
    setLightboxIndex(0);
  };

  const navigateLightbox = (direction) => {
    const newIndex = direction === 'next' 
      ? (lightboxIndex + 1) % filteredPhotos.length
      : (lightboxIndex - 1 + filteredPhotos.length) % filteredPhotos.length;
    
    setLightboxIndex(newIndex);
    setLightboxPhoto(filteredPhotos[newIndex]);
  };

  if (!isActive) return null;

  return (
    <div className="w-full h-full bg-white dark:bg-gray-900 relative overflow-hidden">
      {/* Header */}
      <div className="absolute top-0 left-0 right-0 z-10 bg-white/90 dark:bg-gray-900/90 backdrop-blur-sm border-b border-gray-200 dark:border-gray-700 p-4">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Foto-Galerie</h2>
            <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
              {photos.length} Fotos • {selectedProperty?.name || 'Maisonette-Wohnung Mannheim D3,1'}
            </p>
          </div>
          
          <div className="flex items-center space-x-2">
            <button className="flex items-center space-x-2 px-3 py-2 bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors">
              <Upload className="w-4 h-4" />
              <span className="hidden sm:inline">Upload</span>
            </button>
            
            <button className="flex items-center space-x-2 px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
              <Sparkles className="w-4 h-4" />
              <span className="hidden sm:inline">KI-Sortierung</span>
            </button>
          </div>
        </div>

        {/* Search Bar */}
        <div className="relative mb-4">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
          <input
            type="text"
            placeholder="Fotos durchsuchen..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>
        
        {/* Category Filters */}
        <div className="flex flex-wrap gap-2">
          {categoriesWithCounts.map((category) => {
            const IconComponent = category.icon;
            return (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`flex items-center space-x-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                  selectedCategory === category.id
                    ? 'bg-blue-600 text-white'
                    : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'
                }`}
              >
                <IconComponent className="w-4 h-4" />
                <span>{category.name}</span>
                {category.count > 0 && (
                  <span className={`px-1.5 py-0.5 rounded-full text-xs ${
                    selectedCategory === category.id
                      ? 'bg-white/20 text-white'
                      : 'bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-400'
                  }`}>
                    {category.count}
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>

      {/* Content */}
      <div className="pt-48 p-4 h-full overflow-y-auto">
        {isLoading ? (
          <div className="flex items-center justify-center h-64">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
              <p className="text-gray-600 dark:text-gray-400">Fotos werden geladen...</p>
            </div>
          </div>
        ) : filteredPhotos.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-64 text-gray-500 dark:text-gray-400">
            <Grid className="w-16 h-16 mb-4 opacity-50" />
            <h3 className="text-lg font-medium mb-2">Keine Fotos gefunden</h3>
            <p className="text-sm text-center">
              {searchTerm 
                ? `Keine Ergebnisse für "${searchTerm}"`
                : selectedCategory === 'all' 
                  ? 'Laden Sie Fotos über die Documents-Seite hoch'
                  : `Keine Fotos in der Kategorie "${categoriesWithCounts.find(c => c.id === selectedCategory)?.name}"`
              }
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {filteredPhotos.map((photo, index) => (
              <div
                key={photo.id}
                className="group relative aspect-square bg-gray-100 dark:bg-gray-800 rounded-lg overflow-hidden cursor-pointer hover:shadow-lg transition-all duration-200"
                onClick={() => openLightbox(photo, index)}
              >
                <img
                  src={photo.url}
                  alt={photo.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200"
                  onError={(e) => {
                    e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgdmlld0JveD0iMCAwIDQwMCAzMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI0MDAiIGhlaWdodD0iMzAwIiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik0xNzUgMTI1SDE2MFYxNDBIMTc1VjEyNVoiIGZpbGw9IiM5Q0EzQUYiLz4KPHA+';
                  }}
                />
                
                {/* Overlay */}
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-200" />
                
                {/* Actions */}
                <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                  <div className="flex space-x-1">
                    <button className="p-1.5 bg-white/90 rounded-full hover:bg-white transition-colors">
                      <Eye className="w-3 h-3 text-gray-700" />
                    </button>
                    <button className="p-1.5 bg-white/90 rounded-full hover:bg-white transition-colors">
                      <Download className="w-3 h-3 text-gray-700" />
                    </button>
                  </div>
                </div>

                {/* Room Badge */}
                <div className="absolute top-2 left-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                  <span className="px-2 py-1 bg-blue-600/90 text-white text-xs font-medium rounded-full">
                    {photo.room}
                  </span>
                </div>
                
                {/* Title */}
                <div className="absolute bottom-0 left-0 right-0 p-2 bg-gradient-to-t from-black/60 to-transparent">
                  <p className="text-white text-xs font-medium truncate">
                    {photo.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Lightbox Modal */}
      {lightboxPhoto && (
        <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center">
          <button
            onClick={closeLightbox}
            className="absolute top-4 right-4 p-2 text-white hover:bg-white/10 rounded-full transition-colors z-10"
          >
            <X className="w-6 h-6" />
          </button>
          
          {/* Navigation */}
          {filteredPhotos.length > 1 && (
            <>
              <button
                onClick={() => navigateLightbox('prev')}
                className="absolute left-4 p-2 text-white hover:bg-white/10 rounded-full transition-colors z-10"
              >
                <ChevronLeft className="w-6 h-6" />
              </button>
              <button
                onClick={() => navigateLightbox('next')}
                className="absolute right-16 p-2 text-white hover:bg-white/10 rounded-full transition-colors z-10"
              >
                <ChevronRight className="w-6 h-6" />
              </button>
            </>
          )}
          
          {/* Image */}
          <div className="max-w-4xl max-h-[80vh] mx-4">
            <img
              src={lightboxPhoto.url}
              alt={lightboxPhoto.title}
              className="max-w-full max-h-full object-contain"
            />
          </div>
          
          {/* Info */}
          <div className="absolute bottom-4 left-4 right-4 text-white z-10">
            <div className="bg-black/50 backdrop-blur-sm rounded-lg p-4">
              <h3 className="text-lg font-medium mb-1">{lightboxPhoto.title}</h3>
              <p className="text-sm opacity-75 mb-2">
                {lightboxIndex + 1} von {filteredPhotos.length} • {lightboxPhoto.room}
              </p>
              {lightboxPhoto.description && (
                <p className="text-sm opacity-90">{lightboxPhoto.description}</p>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Action Buttons */}
      <div className="absolute bottom-4 right-4 flex flex-col space-y-2">
        <button className="p-3 bg-blue-600 text-white rounded-full shadow-lg hover:bg-blue-700 transition-colors">
          <Share2 className="w-5 h-5" />
        </button>
        <button className="p-3 bg-green-600 text-white rounded-full shadow-lg hover:bg-green-700 transition-colors">
          <Download className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default PhotoGallery;
